import { bootstrapApplication } from '@angular/platform-browser';
import { registerLocaleData } from '@angular/common';
import localeSk from '@angular/common/locales/sk';

import { App } from './app/app.component';
import { appConfig } from './app/app.config';

registerLocaleData(localeSk);

bootstrapApplication(App, appConfig).catch((err) => console.error(err));
